module.exports = __webpack_public_path__ + "static/media/DATABASEMIGRATION.d25ee956.svg";